<template>
  <div name="logical-statement-lists" class="list-card clearfix" v-if="lists.length > 0">
    <div class="clearfix">
      <i class="group-icon color-skin fa fa-object-group" title="click for group linked statements" v-show="totalLink >= 3" @click="groupList()"></i>
      <i class="group-icon color-skin fa fa-object-group -disable" title="required minimum 3 linked statements for grouping" v-show="totalLink < 3"></i>
    </div>
    <draggable v-model="myLists" @end="onEnd()">
      <transition-group>
        <list-main  v-for="(list, index) in myLists" :key="list.id"
                   :totalLists="lists.length"
                   :nowLang="nowLang"
                   :labelCodsex="labelCodsex"
                   :list="list"
                   :index="index"
                   :setDescConjAndDescStmt="setDescConjAndDescStmt"
                   :linkList="linkList"
                   :unlinkList="unlinkList"
                   :ungroupList="ungroupList"
                   :viewList="viewList"
                   :editList="editList"
                   :deleteList="deleteList"
                   :findValueType="findValueType"
                   :findInputType="findInputType"
                   :findLovType="findLovType"                   
                   :listFields="listFields"
                   :listConjunctions="listConjunctions"
                   :listOperators="listOperators" />
      </transition-group>
    </draggable>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import listMain from 'components/hrmsLogicalStatement/listMain'

  export default {
    name: 'logical-statement-lists',
    data () {
      return {
        myLists: this.lists
      }
    },
    watch: {
      lists (newVal) {
        this.myLists = newVal
      },
      myLists (newVal) {
        this.$emit('setLists', newVal)
      }
    },
    methods: {
      onEnd () {
        this.$emit('setLists', this.myLists)
      }
    },
    components: {
      draggable,
      listMain
    },
    props: {
      nowLang: {
        type: String,
        default: 'th'
      },
      labelCodsex: {
        type: Object
      },
      lists: {
        type: Array,
        required: true
      },
      listFields: {
        type: Array,
        required: true
      },
      listConjunctions: {
        type: Object,
        required: true
      },
      listOperators: {
        type: Array,
        required: true
      },
      setDescConjAndDescStmt: {
        type: Function
      },
      findValueType: {
        type: Function
      },
      findInputType: {
        type: Function
      },
      findLovType: {
        type: Function
      },
      viewList: {
        type: Function
      },
      editList: {
        type: Function
      },
      deleteList: {
        type: Function
      },
      linkList: {
        type: Function
      },
      unlinkList: {
        type: Function
      },
      groupList: {
        type: Function
      },
      ungroupList: {
        type: Function
      },
      totalLink: {
        type: Number
      }
    }
  }
</script>


// WEBPACK FOOTER //
// lists.vue?3bc48264